import { createI18n } from 'vue-i18n'
import zh from './zh'
import en from './en'

export function createAppI18n() {
  const locale = typeof localStorage !== 'undefined'
    ? (localStorage.getItem('gibbous-web-lang') || 'zh')
    : 'zh'

  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'zh',
    messages: { zh, en },
  })
}

export default createAppI18n
